


import React, { useState } from "react";
import { motion } from "framer-motion";
import PersonImage from "./Images/VIKAS_STUDENT_PIC[1].png";
import QRImage from "./Images/qr-code.png";

const Getapps = () => {
  const [showPopup, setShowPopup] = useState(false);
  const togglePopup = () => setShowPopup(!showPopup);

  return (

    <>
      <style>{`
        .promo-container {
          display: flex;
          justify-content: space-between;
          align-items: center;
          background-color: #2a0947;
          padding: 50px;
          flex-wrap: wrap;
          margin-top:-67px;
        }
          .promo-heading {
          font-size: 30px;
          font-weight: bold;
          text-align: center;
          margin-bottom: 40px;
        }

        .text-grid {
          display: grid;
          grid-template-rows: repeat(2, auto);
          grid-template-columns: repeat(3, 1fr);
          gap: 30px;
          max-width: 50%;
          color: white;
          font-family: Arial, sans-serif;
        }

        .text-box {
          padding: 10px;
          background-color: white;
          border-radius: 10px;
        }

        .text-heading {
          font-size: 22px;
          font-weight: bold;
          color: #2a0947;
        }

        .text-subtext {
          font-size: 16px;
          margin-top: 5px;
             color: #2a0947;
        }

        .image-side {
          max-width: 45%;
        }

        .promo-image {
          width: 100%;
          border-radius: 10px;
        }

        .downloadBtnyy {
          margin-top: 30px;
          background-color: #ffe124;
          color: #2a0947;
          padding: 12px 25px;
          font-size: 18px;
          border: none;
          border-radius: 8px;
          cursor: pointer;
          font-weight: bold;
        }

        .popupOverlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0, 0, 0, 0.6);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .popupInner {
          background: white;
          padding: 30px;
          border-radius: 10px;
          text-align: center;
          max-width: 400px;
          position: relative;
        }

        .closeBtn {
          position: absolute;
          top: 10px;
          right: 15px;
          background: none;
          border: none;
          font-size: 20px;
          cursor: pointer;
        }

        .scannerImg {
          width: 200px;
          margin-bottom: 15px;
        }

        @media (max-width: 768px) {
          .promo-container {
            flex-direction: column-reverse;
            padding: 30px 20px;
          }

          .text-grid {
            max-width: 100%;
            grid-template-columns: repeat(1, 1fr);
            margin-top: 30px !important;
          }

          .image-side {
            max-width: 90%;
            margin-bottom: 20px;
          }
        }
        @media(min-width : 990px) {
          .whylovemaamaas{
            margin-bottom: 20px;
          }
        }
      `}</style>

      <div style={{ textAlign: "center", marginTop: '30px', backgroundColor: '#2a0947', maxwidth: '50%' }}>
        <h1 className="whylovemaamaas"
          style={{
            fontSize: "50px",
            fontFamily: "Lato, sans-serif",
            position: "relative",
            display: "inline-block",
            fontWeight: 'bold',
            color: "white",
            backgroundColor: '#2a0947',
            marginTop: '30px',
            marginBottom: "17px",
          }}
        >
          Why You’ll Love <span style={{ color: "rgb(255 225 36)" }}> Maamaas </span>
          <span

          />
        </h1>
      </div>
      <div className="promo-container">


        {/* Left Text Section */}

        <motion.div
          className="image-side"
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >

          <img src={PersonImage} alt="Promotional" className="promo-image" />
        </motion.div>

        <motion.div
          className="text-grid"
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
        >
          <div className="text-box">
            <div className="text-heading">Fair Pricing </div>
            <div className="text-subtext">No hidden fees, no inflated bills.</div>
          </div>
          <div className="text-box">
            <div className="text-heading">All-in-One Convenience</div>
            <div className="text-subtext">One login, all your services</div>
          </div>
          <div className="text-box">
            <div className="text-heading">Local First</div>
            <div className="text-subtext">Support your neighborhood businesses</div>
          </div>
          <div className="text-box">
            <div className="text-heading">Zero Commission Model </div>
            <div className="text-subtext">More value for your money</div>
          </div>
          <div className="text-box">
            <div className="text-heading">Safe, Simple, and Transparent</div>
            <div className="text-subtext">Just the way it should be</div>
          </div>
          <div className="text-box">
            <div className="text-heading">More Services</div>
            <div className="text-subtext">Expanding everyday to serve you better.</div>
          </div>

          <div className="buttonContainer" style={{ justifyContent: 'center' }}>
            <button className="downloadBtn" onClick={togglePopup}>
              Download App
            </button>
          </div>

          {showPopup && (
            <div className="popupOverlay">
              <div className="popupInner">
                <button className="closeBtn" onClick={togglePopup}>
                  ×
                </button>
                <img src={QRImage} alt="QR Code Scanner" className="scannerImg" />
                <p style={{ color: 'black' }}>Scan the QR code to download the Maamaas App!</p>
              </div>
            </div>
          )}
        </motion.div>

        {/* Right Image Section */}

      </div>
    </>
  );
};

export default Getapps;




